export default "__VITE_ASSET__B0vE9sqD__"